"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryKeys = void 0;
var QueryKeys;
(function (QueryKeys) {
    QueryKeys["FORM_CONTENT"] = "form_content";
    QueryKeys["GET_CUSTOMER_HIDDEN_DATA"] = "get_customer_hidden_data";
})(QueryKeys = exports.QueryKeys || (exports.QueryKeys = {}));
